import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import { Upload } from "antd";
import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { IconClose } from "@/components/Icon";
import { useTranslation } from "@/langs/useTranslation";
import { toast } from "@/apis/request";

const useStyles = makeStyles(theme => ({
  root: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    padding: "10px 0",
    "& .ant-upload-picture-card-wrapper": {
      width: "auto"
    },
    "& .ant-upload.ant-upload-select-picture-card": {
      width: 80,
      height: 80
    },
    "& .upload-right": {
      flex: 1,
      height: 80,
      display: "flex",
      alignItems: "center",
      paddingLeft: 20
    }
  },
  imageBox: {
    position: "relative",
    width: "100%",
    height: "100%",
    "& .icon-box": {
      width: 24,
      height: 24,
      position: "absolute",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "rgba(0,0,0,0.3)",
      right: 0,
      cursor: "pointer",
      "& .icon-close": {
        color: "#ffffff",
        right: 0,
        fontSize: 20
      }
    }
  }
}));
/**
 * 将图像文件转换为Base64编码，并通过回调函数返回结果
 * @param img
 * @param callback
 */
const getBase64 = (img, callback) => {
  const reader = new FileReader();
  reader.addEventListener("load", () => callback(reader.result));
  reader.readAsDataURL(img);
};
/**
 * 上传图片组件，接收图片源和更改回调函数作为props
 * @param imageSrc
 * @param onChange
 * @returns {JSX.Element}
 * @constructor
 */
const UploadImage = ({ imageSrc, onChange, disabled = false }) => {
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState();

  const styleClass = useStyles();
  const { t } = useTranslation();

  const beforeUpload = file => {
    const isJpgOrPng =
      file.type === "image/jpeg" ||
      file.type === "image/png" ||
      file.type === "image/jpg" ||
      file.type === "image/bmp" ||
      file.type === "image/gif" ||
      file.type === "image/svg+xml" ||
      file.type === "image/webp";
    if (!isJpgOrPng) {
      toast.error(t({ defaultMessage: "上传格式有误" }));
      return false;
    }
    const isLt2M = file.size / 1024 < 500;
    if (!isLt2M) {
      toast.error(t({ defaultMessage: "图片大小不能超过500KB" }));
      return false;
    }
    getBase64(file, url => {
      setLoading(false);
      setImageUrl(url);
      onChange &&
        onChange({
          file: file,
          base64Img: url
        });
    });
    return false;
    // return isJpgOrPng && isLt2M;
  };

  const handleChange = info => {
    if (info.file.status === "uploading") {
      setLoading(true);
      return;
    }
    if (info.file.status === "done") {
      // Get this url from response in real world.
      getBase64(info.file.originFileObj, url => {
        setLoading(false);
        setImageUrl(url);
      });
    }
  };

  const handleRemove = e => {
    e.stopPropagation();
    setImageUrl("");
    onChange &&
      onChange({
        file: "",
        base64Img: ""
      });
  };

  const uploadButton = (
    <div className={`uploadButton`}>
      {loading ? (
        <LoadingOutlined style={{ fontSize: 24 }} />
      ) : (
        <PlusOutlined style={{ fontSize: 24 }} />
      )}
    </div>
  );
  return (
    <div className={styleClass.root}>
      <Upload
        name="avatar"
        listType="picture-card"
        className="avatar-uploader"
        showUploadList={false}
        action={false}
        accept="image/png,image/jpeg,image/jpg,image/bmp,image/gif,image/svg+xml,image/webp"
        beforeUpload={beforeUpload}
        onChange={handleChange}
        disabled={disabled}
      >
        {imageUrl ? (
          <div className={styleClass.imageBox}>
            <div
              className={`icon-box`}
              onClick={e => {
                handleRemove(e);
              }}
            >
              <IconClose className={`icon-close`} />
            </div>
            <img
              src={imageUrl}
              alt="avatar"
              style={{
                width: "100%",
                height: "100%"
              }}
            />
          </div>
        ) : (
          uploadButton
        )}
      </Upload>
      <div className={`upload-right`}>
        {t({ defaultMessage: "图片最大尺寸：500KB" })}
        <br />
        {t({ defaultMessage: "图片格式：PNG、JPG、JPEG、BMP、GIF、SVG、WEBP" })}
      </div>
    </div>
  );
};
export default UploadImage;
